import axios from "utils/axios";

/**
 * Parse candidate resume data from S3 URL (optimized - no duplicate upload)
 * @param {String} candidate : candidate ID
 * @param {String} s3Location : S3 URL of uploaded resume
 * @param {String} mimeType : MIME type of the file
 * @param {String} job : optional job ID for analysis
 * @returns Promise object
 */
export const parseResumeFromS3 = (candidate, s3Location, mimeType, job = "") =>
  new Promise((resolve, reject) => {
    axios
      .post(`/cv/parser/resume/candidate/${candidate}${job ? `/${job}` : ""}`, {
        fileLocation: s3Location,
        mimeType: mimeType
      }, {
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error));
  });

export const getResumeData = (candidate) =>
  new Promise((resolve, reject) => {
    axios
      .get(`/cv/parser/resume/get/list/candidate/${candidate}`)
      .then((response) => {
        resolve(response);
      })
      .catch((error) => {
        reject(error);
      });
  });

export const updateResume = (candidate, data) =>
  new Promise((resolve, reject) => {
    // Safety guard: avoid PATCHing when candidate id is falsy
    if (!candidate) {
      console.warn("[updateResume] Skipped update - missing candidate id");
      resolve({ data: { success: true, skipped: true, reason: "missing_candidate" } });
      return;
    }
    // Avoid sending empty updates
    if (!data || (typeof data === "object" && Object.keys(data).length === 0)) {
      console.warn("[updateResume] Skipped update - empty payload");
      resolve({ data: { success: true, skipped: true, reason: "empty_payload" } });
      return;
    }
    axios
      .patch(`/cv/parser/resume/update/candidate/${candidate}`, data)
      .then((response) => resolve(response))
      .catch((error) => reject(error));
  });
